import { createContext, useContext } from 'react';

export interface BrandKitContextValue {
  approved: boolean;
  selectedId: string;
  kitName: string;
  isLoading: boolean;
  setSelected: (id: string) => void;
  approve: () => void;
  unapprove: () => void;
}

export const BrandKitContext = createContext<BrandKitContextValue>({
  approved: false,
  selectedId: 'warm',
  kitName: 'Warm & Familiar',
  isLoading: false,
  setSelected: () => {},
  approve: () => {},
  unapprove: () => {},
});

export function useBrandKit() {
  return useContext(BrandKitContext);
}
